export default __webpack_public_path__ + "4c75248c4b0f07d190c61114a0f90b02.svg";